import { render, staticRenderFns } from "./ChatsMessage.vue?vue&type=template&id=21448a94"
import script from "./ChatsMessage.vue?vue&type=script&lang=js"
export * from "./ChatsMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatsMessage.vue?vue&type=style&index=0&id=21448a94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports